import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const getAllLearnMore = async () => {
  try {
    return await getData(`/website/home/learn-more`);
  } catch (error) {
    console.log(error);
  }
};

export const getAllPrivacyAgreement = async () => {
  try {
    return await getData(`/website/home/privacy-agreement`);
  } catch (error) {
    console.log(error);
  }
};

export const getAllRiskDisclosure = async () => {
  try {
    return await getData(`/website/home/risk-disclosure`);
  } catch (error) {
    console.log(error);
  }
};

export const getAllComplaintHandlingPolicy = async () => {
  try {
    return await getData(`/website/home/complaint-handling-policy`);
  } catch (error) {
    console.log(error);
  }
};

export const getAllLegalDocument = async () => {
  try {
    return await getData(`/website/home/legal-document`);
  } catch (error) {
    console.log(error);
  }
};

export const getAllSecurityInstructions = async () => {
  try {
    return await getData(`/website/home/security-instructions`);
  } catch (error) {
    console.log(error);
  }
};

export const getAllPreventMoneyLaundering = async () => {
  try {
    return await getData(`/website/home/prevent-money-laundering`);
  } catch (error) {
    console.log(error);
  }
};
